class ProductImageGallery {

    /**
     * ProductImageGallery constructor
     * @param $thumbnailSlider
     * @param $thumbnailNavigationSlider
     */
    constructor($thumbnailSlider = null, $thumbnailNavigationSlider = null,) {
        if ($thumbnailSlider.length === 0 || !$thumbnailSlider instanceof Element) throw new Error('Missing required parameter `$thumbnailSlider` in class ProductImageGallery or given parameter was not an Element.');

        let $thumbnailNavigationElements = false;

        // If no thumbnail navigation slider is given, search for individual navigation items.
        if (!$thumbnailNavigationSlider || $thumbnailNavigationSlider.length === 0) {
            $thumbnailNavigationElements = jQuery('.single-product-gallery .single-product-gallery__navigation-item');
        }

        this.state = {
            $thumbnailSlider: $thumbnailSlider,
            $thumbnailNavigationSlider: $thumbnailNavigationSlider,
            $thumbnailNavigationElements: $thumbnailNavigationElements
        }

        // Init sliders
        this.initMainSlider();

        // Initialize the thumbnail slider as the navigation.
        if ($thumbnailNavigationSlider && $thumbnailNavigationSlider.length > 0) this.initThumbnailNavigationSlider();

        // Initialize the individual thumbnail anchors as the navigation.
        if ($thumbnailNavigationElements && $thumbnailNavigationElements.length > 0) this.initThumbnailNavigationItems();

        // Synchronize both sliders with each other.
        if ($thumbnailNavigationSlider && $thumbnailNavigationSlider.length > 0 ) this.initSliderSync();

    }

    /**
     * Init the slider that shows them main gallery image
     * @param event
     */
    initMainSlider(event) {
        const sliderArgs = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            adaptiveHeight: true,
            speed: 100,
            prevArrow: "<a href='#' class='arrow prev'><i class='icon angle-left'></i></a>",
            nextArrow: "<a href='#' class='arrow next'><i class='icon angle-right'></i></a>",
            infinite: false
        };
        this.state.$thumbnailSlider.slick(sliderArgs);
    }

    /**
     * Init the slider that uses the thumbnails as navigation buttons
     * @param event
     */
    initThumbnailNavigationSlider(event) {
        if (this.state.$thumbnailNavigationSlider && this.state.$thumbnailSlider) {
            this.state.$thumbnailNavigationSlider.slick({
                slidesToShow: 12.3,
                slidesToScroll: 12,
                dots: false,
                speed: 100,
                arrows: false,
                centerMode: false,
                variableWidth: true,
                focusOnSelect: false,
                infinite: false,
                touchThreshold: 10,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 6.3,
                            slidesToScroll: 6,
                            variableWidth: true,
                            centerMode: true,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3.3,
                            slidesToScroll: 3,
                            variableWidth: false,
                            centerMode: true,
                        }
                    },
                ]
            });
        }
    }

    /**
     * Init the thumbnail anchors as the slick slider navigation.
     * @param event
     */
    initThumbnailNavigationItems(event) {

        if (this.state.$thumbnailNavigationElements) {

            const self = this; // Preserve context

            this.state.$thumbnailNavigationElements.each(function (index, item) {

                jQuery(item).on('click', function (e) {
                    e.preventDefault(); // Prevent default anchor click behavior

                    // Get the index of the clicked navigation element
                    const targetIndex = jQuery(item).index();

                    // Use Slick's `slickGoTo` method to navigate to the corresponding slide
                    if (self.state.$thumbnailSlider) {
                        self.state.$thumbnailSlider.slick('slickGoTo', targetIndex);
                    }
                });

            });

        }

    }

    /**
     * Init the sync between main and navigation slider
     * @param event
     */
    initSliderSync(event) {

        const self = this; // Preserve context

        this.state.$thumbnailNavigationSlider.addClass("remove-center-transform");

        this.state.$thumbnailSlider.on('afterChange', function(event, slick, currentSlide) {
            self.state.$thumbnailNavigationSlider.slick('slickGoTo', currentSlide);
            self.state.$thumbnailNavigationSlider.find('.slick-slide.slick-current').removeClass('slick-current');
            self.state.$thumbnailNavigationSlider.find(`.slick-slide[data-slick-index="${currentSlide}"]`).addClass('slick-current');
            if (currentSlide > 3) {
                self.state.$thumbnailNavigationSlider.removeClass("remove-center-transform");
            } else {
                self.state.$thumbnailNavigationSlider.addClass("remove-center-transform");
            }
        });


        this.state.$thumbnailNavigationSlider.on('click', '.slick-slide', function(event) {
            event.preventDefault();
            var goToSingleSlide = jQuery(this).data('slick-index');
            self.state.$thumbnailSlider.slick('slickGoTo', goToSingleSlide);
        });
    }

}

export default ProductImageGallery